import { queryClient } from '@/lib/queryClient'
import { flattenPages } from '@/utils/flattenPages'

import { QueryKeys } from '@/enums'

import { getReactionActivityId } from '../../getReactionActivityId'

export const getCategoriesFeedActivityIds = () => {
  const categoriesFeedQueriesData = queryClient.getQueriesData({
    queryKey: [QueryKeys.CategoryFeed],
  })
  const categoriesFeedActivityIds = []

  categoriesFeedQueriesData.forEach((categoryFeedQueryData) => {
    const categoryFeedData = categoryFeedQueryData[1]
    const categoryFeed = flattenPages(categoryFeedData, 'data')

    categoryFeed.forEach((activity) => {
      const reactionActivityId = getReactionActivityId(activity)

      categoriesFeedActivityIds.push(reactionActivityId)
    })
  })

  return categoriesFeedActivityIds
}
